/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

// 起始 z-index
export const BASE_Z_INDEX = 8;
